module.exports = __webpack_public_path__ + "static/media/process_1.461bceb0.png";